<template>
  <v-card min-width="350" color="blue-grey lighten-5">
    <v-card-title>
      <div class="ma-3 text-align-center">
        <div class="title mb-0 black--text">Logged in as {{ accountDescription }}</div>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-container row fill-height>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <v-btn color="primary" @click="logout">
            Logout
          </v-btn>
        </v-flex>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'usermenu',
  methods: {
    logout: function () {
      this.$store.commit('set_authtoken',null)
    }
  },
  computed: {
    accountDescription: function () {
      return this.$store.getters.auth_desc
    }
  }
}
</script>

<style scoped>
</style>
